"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMobile;
/**
  * Check if breakpoint is mobile.
  *
  * @param {String} breakpoint - current breakpoint
  * @returns {Boolean} Mobile or not.
  * @public
  * @TODO
  */
function isMobile(breakpoint) {
  return ['mobile', 'phablet'].includes(breakpoint);
}